export default __webpack_public_path__ + "static/media/020_start.last.6c24b070.avif";